/** Type guard that validates a stat to be of type ProjectStat */
export function isProjectStat(stat) {
  return stat.name === "project-count" || stat.name === "project-count-abs";
}

/** Type guard that validates a stat to be of type ProjectSqftStat */
export function isProjectSqftStat(stat) {
  return stat.name === "project-sqft" || stat.name === "project-sqft-abs";
}

/** Type guard that validates a stat to be of type ProjectSpheresStat */
export function isProjectSpheresStat(stat) {
  return stat.name === "project-spheres" || stat.name === "project-spheres-abs";
}

/** Type guard that validates a stat to be of type ProjectSheetsStat */
export function isProjectSheetsStat(stat) {
  return stat.name === "project-sheets" || stat.name === "project-sheets-abs";
}

/** Type guard that validates a stat to be of type CumulativeStat */
export function isCumulativeStat(stat) {
  return stat["data-generation"] === "cumulative";
}

/** Type guard that validates a stat to be of type DifferentialStat */
export function isDifferentialStat(stat) {
  return stat["data-generation"] === "differential";
}

/** Type guard that validates a stat pair to be of type StatPair */
export function isStatPair(statPair) {
  return "cumulative" in statPair && "differential" in statPair;
}